import { Box } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import Breadcrumbs from "../src/components/common/Breadcrumbs";

import { MemoizedFooter } from "../src/layouts/footer";
import { MemoizedHeader } from "../src/layouts/header";
import { MemoizedReferralMain } from "../src/modules/Refferal/referral";
import { sendAnalytics } from "../src/utils/analyticsCommon";

const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Referral" },
];

const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Referral",
      item: "https://www.turno.club/referral",
    },
  ],
};

export default function Referral() {
  useEffect(() => {
    sendAnalytics("screen_viewed", { screen_name: "referral_screen" }, "en");
  }, []);
  return (
    <>
      <Head>
        <title>Turno.club - Refer your friends & earn up to Rs. 5000</title>
        <meta
          name="description"
          content="Refer electric vehicles from Turno to your friend and earn cashback. Get great offers on EVs or electric auto in India with Turno."
        />
        <meta
          name="keywords"
          content="Turno, EV Vehicles, Loading Vehicle, Electric Commercial Vehicle, refer and earn, refer to earn, refer and earn money, cash price, referral, refer and win cash"
        />
        <meta name="author" content="Turno" />
        <meta name="url" content="https://www.turno.club/referral" />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Facebook */}
        <meta property="og:url" content="https://www.turno.club/referral" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Turno.club - Refer your friends & earn up to Rs. 5000"
        />
        <meta
          property="og:description"
          content="Refer electric vehicles from Turno to your friend and earn cashback. Get great offers on EVs or electric auto in India with Turno."
        />
        <meta property="og:image" content="/logoIcon.png" />
        <meta property="fb:app_id" content="5796260583761767" />
        <meta property="fb:pages" content="646488286564232" />
        {/* Twitter */}
        <meta
          name="twitter:description"
          content="Refer electric vehicles from Turno to your friend and earn cashback. Get great offers on EVs or electric auto in India with Turno."
        />
        <meta
          name="twitter:title"
          content="Turno.club - Refer your friends & earn up to Rs. 5000"
        />
        <meta name="twitter:site" content="@Turno" />
        <meta name="twitter:creator" content="@Turno" />
        <meta name="twitter:url" content="https://www.turno.club/referral" />
        <meta
          name="twitter:app:id:googleplay"
          content="com.customerapp.turno.turno_customer_application"
        />
        <meta name="twitter:app:country" content="IN" />

        <link rel="canonical" href="https://www.turno.club/referral" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>

      <MemoizedHeader />
      <MemoizedReferralMain />
      <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
        <Breadcrumbs items={BREADCRUMB_ITEMS} />
      </Box>
      <MemoizedFooter />
    </>
  );
}
